import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
button {
    cursor: pointer;
}
select {
  cursor: pointer;
}
option {
  cursor: pointer;
}
:root {
  --colorPrimary: #FD377E;
  --ColorPrimary2: #E34981;
  --ColorSecondary: #03B898;
  --grey1: #F8F9FA;
  --grey2: #E9ECEF;
  --grey3: #868E96;
  --grey4: #212529;
  --feedBackNegative: #e60000;
  --feedBackWarning: #ffcd07;
  --feedBackSucess: #168821;
  --feedBackInformation: #155bcb;
  --white: #ffffff;
}
.none {
  display: none;
}

.show{
  display: block
}



@media (min-width: 900px) {

  .containerMain {
    width: 75%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 50px;
  } 
}




`;
